import { createSelector } from '@reduxjs/toolkit';

import { getProjectModelIdsForIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectModelIdsForIriSelector = memoizeSelectorFactory(
  (projectId: string, iri?: string) =>
    createSelector(projectSelector(projectId), (project) =>
      project && iri ? getProjectModelIdsForIri(iri, project.diagram.model) : []
    )
);
